import * as React from 'react';
import classNames from 'classnames';
import { LucideIcon } from 'lucide-react';

interface InputProps extends React.ComponentProps<'input'> {
  error?: string;
  icon?: LucideIcon;
}

function Input({ className, type, icon: Icon, ...props }: InputProps) {
  return (
    <div className={`flex w-full flex-col gap-1`}>
      <div className='relative'>
        <input
          type={type}
          data-slot='input'
          className={classNames(
            'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
            'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
            'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
            {
              'border-rose-600 dark:border-rose-400': props?.error,
              'pr-9': Icon,
            },
            className,
          )}
          {...props}
        />
        {Icon && (
          <div className='absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground'>
            <Icon className='h-4 w-4' />
          </div>
        )}
      </div>
      {props?.error && (
        <span className='text-xs text-rose-600 pl-[13px] dark:text-rose-400 break-words'>
          {props?.error}
        </span>
      )}
    </div>
  );
}

export { Input };
